export default "__VITE_ASSET__DRwaJujJ__"